import { z } from 'zod';

export const ReservationMode = [
  'delivery',
  'pickup',
  'curbside',
  'kiosk',
] as const;
export type ReservationMode = (typeof ReservationMode)[number];

/** Reservation modes supported by Premium for shopping. */
const PremiumReservationMode = ['delivery', 'pickup'] as const;
export const PremiumReservationModeSchema = z.enum(PremiumReservationMode);

export type PremiumReservationMode = (typeof PremiumReservationMode)[number];
